import { createRouter, createWebHistory } from 'vue-router';
import { useKeycloak } from '@josempgon/vue-keycloak';

const routes = [
  {
    path: '/',
    name: 'Home',
    alias: '/home',
    component: () => import('@/views/Home.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/connections',
    name: 'Connections',
    alias: '/connections',
    component: () => import('@/views/ConnectionParameterView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    alias: '/settings',
    component: () => import('@/views/ConfigurationView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/idcards',
    name: 'Idcards',
    alias: '/idcards',
    component: () => import('@/views/IdCardView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/bookings',
    name: 'Bookings',
    alias: '/bookings',
    component: () => import('@/views/TimebookingView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/appuser',
    name: 'AppUser',
    alias: '/appuser',
    component: () => import('@/views/AppUserView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/log',
    name: 'Log',
    alias: '/log',
    component: () => import('@/views/LogView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/accesslog',
    name: 'AccessLog',
    alias: '/accesslog',
    component: () => import('@/views/AccessLogView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/workflows',
    name: 'Workflows',
    alias: '/workflows',
    component: () => import('@/views/WorkflowDashboardView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/badges',
    name: 'Badges',
    alias: '/badges',
    component: () => import('@/views/BadgeView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminal/groups',
    name: 'TerminalGroups',
    alias: '/terminalgroups',
    component: () => import('@/views/terminal/TerminalGroup.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminal/systems',
    name: 'TerminalSystems',
    alias: '/terminalsystems',
    component: () => import('@/views/terminal/TerminalSystemView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminal/devicetypes',
    name: 'TerminalDeviceTypes',
    alias: '/terminaldevicetypes',
    component: () => import('@/views/terminal/TerminalDeviceType.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminal/:type',
    name: 'Terminals',
    alias: '/terminal/:type',
    component: () => import('@/views/terminal/TerminalView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/usergroups',
    name: 'Usergroups',
    alias: '/usergroups',
    component: () => import('@/views/UserGroup.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/employees',
    name: 'Employees',
    alias: '/employees',
    component: () => import('@/views/EmployeeView.vue'),
  },
  {
    path: '/geofences',
    name: 'Geofences',
    alias: '/geofences',
    component: () => import('@/views/GeofenceView.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/appuser-geofences',
    name: 'AppUser Geofences',
    alias: '/appuser-geofences',
    component: () => import('@/views/AppUserGeofenceView.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/timeframes',
    name: 'WorkingTimeFrames',
    alias: '/timeframes',
    component: () => import('@/views/WorkingTimeFrameView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/breaks',
    name: 'Breaks',
    alias: '/breaks',
    component: () => import('@/views/BreakView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/pushmessages',
    name: 'PushMessages',
    alias: '/pushmessages',
    component: () => import('@/views/PushMessageView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/Home.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { isAuthenticated, roles, keycloak } = useKeycloak();

  if (to.meta.requiresAuth) {
    if (!isAuthenticated.value) {
      keycloak.value?.login({
        redirectUri: window.location.origin + to.fullPath,
      });
      return;
    }

    // // Case B: Route requires a specific role
    // if (to.meta.requiresRole && !roles.value.includes(to.meta.requiresRole)) {
    //   return next({ name: 'Unauthorized' })
    // }
  }

  next();
});

export default router;
